/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Partner_Payout_Exception_BlockedInputs */



/**
* | output |
* | --- |
* | "partner(s) blocked — money owed, no credit note possible" |
*
* @param {Partner_Payout_Exception_BlockedInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const partner_payout_exception_blocked = /** @type {((inputs?: Partner_Payout_Exception_BlockedInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Partner_Payout_Exception_BlockedInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Partner gesperrt – Geld fällig, keine Gutschrift möglich")
	return /** @type {LocalizedString} */ ("partner(s) blocked — money owed, no credit note possible")
});